module.exports = __webpack_public_path__ + "static/media/receipt.7d5c2c10.svg";